import React, { useCallback, useState } from 'react';
import { useCookies } from 'react-cookie';
import { DisclaimerModal } from '../disclaimer-modal';
import { VideoThumbnail } from './video-thumbnail';
import config from '../../../../global/env.config';
import './video-thumbnail.scss';
var VideoSource;
(function (VideoSource) {
    VideoSource["vimeo"] = "Vimeo";
    VideoSource["youtube"] = "YouTube";
})(VideoSource || (VideoSource = {}));
const VIDEO_COOKIE_KEY = 'video-disclaimer';
export const VideoThumbnailWrapper = ({ url, title, videoSource, videoThumbnailUrl, }) => {
    const cookieKey = `${VIDEO_COOKIE_KEY}-${videoSource}`;
    const [cookies, setCookie] = useCookies([cookieKey]);
    const [displayVideo, setDisplayVideo] = useState(false);
    const [displayDisclaimerModal, setDisplayDisclaimerModal] = useState(false);
    let fullThumbnailUrl = videoThumbnailUrl;
    // The video thumbnail URL is currently provided as a relative path
    // and we need to convert it to an absolute URL. This condition also allows
    // for future support of absolute URLs.
    if (fullThumbnailUrl && !fullThumbnailUrl.startsWith('http')) {
        const apiUrl = config.apiUrl ?? '';
        fullThumbnailUrl = fullThumbnailUrl.startsWith('/')
            ? `${apiUrl}${fullThumbnailUrl}`
            : `${apiUrl}/${fullThumbnailUrl}`;
    }
    const closeDisclaimerModal = useCallback(() => {
        setDisplayDisclaimerModal(false);
    }, []);
    const onContinue = useCallback(() => {
        closeDisclaimerModal();
        setCookie(cookieKey, '1');
        setDisplayVideo(true);
    }, [cookieKey, closeDisclaimerModal, setCookie]);
    const onThumbnailClick = useCallback(() => {
        const hasPatientAgreed = cookies[cookieKey];
        if (hasPatientAgreed === '1') {
            setDisplayVideo(true);
        }
        else {
            setDisplayDisclaimerModal(true);
        }
    }, [cookieKey, cookies]);
    return (<div className="video-wrapper">
      {displayVideo ? (<iframe title="Embedded video player" allowFullScreen allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" src={url}/>) : (<VideoThumbnail title={title} onClick={onThumbnailClick} videoThumbnailUrl={fullThumbnailUrl}/>)}
      <DisclaimerModal videoSource={VideoSource[videoSource]} isOpen={displayDisclaimerModal} onContinue={onContinue} onClose={closeDisclaimerModal}/>
    </div>);
};
